import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import '../styles/DropNotification.css';
import SingleNotification from './SingleNotification';
import { 
    QuestionCircleFill,
    ExclamationTriangleFill,
    XCircle,
    InfoCircle,
    CheckCircle,
    EnvelopeFill
} from 'react-bootstrap-icons';

export default function DropNotification({className, notifications = '- Nothing new -'}){
    // const [displayNotifications, setDisplaytNotifications] = useState(notifications);
    const [notifications_data, setNotifications] = useState([]);

    const [errorNotifications, setErrorNotifications] = useState({
        type: "",
        message: ""
    });

    const navigate = useNavigate();
    const [userId, setUserId] = useState('');
    const userIdRef = useRef('');
    
    const getNotificationPath = (type) => {
        // TODO update paths
        const paths = {
            "alert": "/overview/main/", 
            "message": "profile/",   
            "info": "/policy",        
            "warning": "respond/",
            "error": "/overview/main/"
        };
        return paths[type] || "/overview/main/"; // Default fallback path
    };

    const getIcon = (txtType) => {
      if (!txtType || typeof txtType !== "string") return <QuestionCircleFill />;

      switch(txtType.toLowerCase()){
        case 'info':
            return <InfoCircle/>;
        case 'message':
            return <EnvelopeFill/>;
        case 'alert':
            return <ExclamationTriangleFill/>;
        case 'warning':
            return <ExclamationTriangleFill/>;
        case 'success':
            return <CheckCircle/>;
        case 'error':
            return <XCircle/>;
        default:
            return <QuestionCircleFill/>;
      }
    }
    
    const getUserId = async () => {
        try {
          const res = await axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true });
          if (res.data.status === 1) {
            setUserId(res.data.id);
            userIdRef.current = res.data.id;
          } 
        } catch (err) {
            //console.error("ERROR: Your session cannot be found!", err);
        }
    }

    const fetchNotifications = async () => {
        try {
            const id_user = userIdRef.current;
            const response = await axios.get(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php/${id_user}`);
            // console.warn("user id: ", id_user);
            // console.warn("got notif: ", response.data);

            if (!response.data || response.data.length === 0 || response.data.status === 0) {
                setNotifications([]); // Explicitly set to empty array
                return;
            }

            const notifications = response.data
            .filter(user => user.id_user === parseInt(id_user, 10)) // Only get notifications of the currently logged-in user
            .map(notif => ({
                id: notif.id,
                db_user: notif.id_user,
                type: notif.type,
                message: notif.message,
                responded: notif.responded,
                updated_responded: notif.updated_responded ? notif.updated_responded : '',
                createdAt: notif.created_at,
                updatedAt: notif.updated_at,
                notifPath: getNotificationPath(notif.type)
            }));

            setNotifications(notifications.length === 0 ? [] : notifications);
            // console.warn("got notif data: ", notifications_data);
        } catch (err) {
            //console.error("cannot get notifications! ", err);
            setNotifications([]);
        }
    }

    useEffect(()=>{
        const fetchData = async () => {
            await getUserId(); // Ensure user ID is fetched first
            fetchNotifications(); // Now fetch notifications safely
        };

        fetchData();

        const interval = setInterval(() => {
            fetchNotifications();
            //console.warn("userIdRef.current is ", userIdRef.current);
        }, 5000) // poll for new notifications every 5 seconds

        return () => clearInterval(interval);
    }, [fetchNotifications])
    // console.warn("Updated notifications: ", notifications_data);
    // useEffect(() => {
    //     console.warn("Updated notifications: ", notifications_data);
    // }, [notifications_data]);

    return (
        <section className={`${className}`}>
            {notifications_data.length > 0 ? (
                notifications_data.map(notification => (
                    // TODO get notifPath from Sidebar
                    <SingleNotification
                        key={notification.id}
                        notifId={notification.id}
                        notifPath={notification.notifPath}
                        notifHeader={notification.type}
                        notifBody={notification.message}
                    />
                ))
            ) : (
                // <Alert variant="info"></Alert>
                <div className='empty-notifications'>
                    No notifications available.
                </div>
            )}
        </section>
    )
}